import { useState, useEffect, useCallback } from "react";
import { fetchImageUrl } from "../../../network/service";
import { getCache, setCache } from "../../../utils/helpers";

export const loadImage = async (
  activeDashboardId,
  widget,
  setBannerData,
  forceFetch
) => {
  const { id, config } = widget;
  const counterCache = getCache();
  const activeWidgetCache = counterCache?.[activeDashboardId]?.[id];
  if (!forceFetch && activeWidgetCache?.image === config.image.imageKey) {
    setBannerData((prevData) => ({
      ...prevData,
      imageURL: activeWidgetCache.imageURL,
    }));
  } else {
    const imageUrlData = await fetchImageUrl(config.image.imageKey);
    if (imageUrlData) {
      setBannerData((prevData) => ({
        ...prevData,
        imageURL: imageUrlData,
      }));
      const tempCounterCache = getCache();
      const updatedCache = {
        ...tempCounterCache,
        [activeDashboardId]: {
          ...tempCounterCache[activeDashboardId],
          [id]: {
            image: config.image.imageKey,
            imageURL: imageUrlData,
          },
        },
      };
      setCache(updatedCache);
    }
  }
};
const useBannerData = (widget, activeDashboardId = "default") => {
  const { id, config } = widget;
  const [bannerData, setBannerData] = useState(config);
  const [loading, setLoading] = useState(true);
  const [reloaded, setReloaded] = useState(false);
  const loadData = useCallback(async (forceFetch) => {
    setLoading(true);
    try {
      if (config?.image)
        await loadImage(activeDashboardId, widget, setBannerData, forceFetch);
    } catch (error) {
      console.error(`Error loading data for widget ${id}:`, error);
    } finally {
      setLoading(false);
    }
  }, []);
  const reloadImage = () => {
    if (!reloaded) loadData(true);
    setReloaded(true);
  };
  useEffect(() => {
    loadData();
  }, []);
  return { bannerData, loading, reloadImage };
};

export default useBannerData;
